module.exports = __webpack_public_path__ + "img/shane.ad8cb57.webp";